<template>
    <router-view></router-view>
</template>

<script>
    import Vue from 'vue';
    import firebase from 'firebase';
    import Component from 'vue-class-component';
    import TheFooter from '@/components/general/TheFooter';
    import TheHeader from '@/components/general/TheHeader';

    @Component
    export default class App extends Vue {
        name = 'app';

        created() {
            console.log('Creating app');
            var config;
            if (process.env.NODE_ENV === 'production') {
                config = {
                    apiKey: "AIzaSyCmjb08qaPVvcDijpmNP83OB1Rfxvvcpgw",
                    authDomain: "mijn-markt-production.firebaseapp.com",
                    databaseURL: "https://mijn-markt-production.firebaseio.com",
                    projectId: "mijn-markt-production",
                    storageBucket: "mijn-markt-production.appspot.com",
                    messagingSenderId: "1092237197443"
                };
            } else {
                config = {
                    apiKey: "AIzaSyCRedIC-AQxtBzLrZ9qhDcfeKZkVYteCgk",
                    authDomain: "mijn-markt-68fbd.firebaseapp.com",
                    databaseURL: "https://mijn-markt-68fbd.firebaseio.com",
                    projectId: "mijn-markt-68fbd",
                    storageBucket: "mijn-markt-68fbd.appspot.com",
                    messagingSenderId: "861876961564"
                };
            }

            firebase.initializeApp(config);
        }
    }
</script>

<!-- Import SCSS boilerplate -->
<style src="./assets/css/styles.scss" lang="scss"></style>




// WEBPACK FOOTER //
// src/App.vue